import {MenuItem} from "@/models/Menu/MenuItem";

export class NavigationService {
     static prefix = '/api/backoffice/navigation'

     static async create(menu) {
        const {data} = await axios.post(`${this.prefix}/menu`, menu)
        return data;
    }

    static async addItem(menuId, menuItem) {
        const {data} = await axios.post(`${this.prefix}/menu/${menuId}/item`, menuItem)
        return data;
    }

    static async updateItem(menuId, menuItem) {
        const {data} = await axios.put(`${this.prefix}/menu/${menuId}/item`, menuItem)
        return data;
    }

    static async removeItem(menuItemId) {
        const {data} = await axios.delete(`${this.prefix}/menu/item/${menuItemId}`)
        return data;
    }
    static async find(menuId, parentId) {
         let endpoint = `${this.prefix}/menu/${menuId}`;
         if(parentId) {
             endpoint += `?menuItemId=${parentId}`;
         }

        const {data} = await axios.get(endpoint)
        let menu = new Menu(data.id, data.title, data.description);

        data.items.forEach((item) => {
            let menuItem = this.menuItem(item)
            menu.items.push(menuItem)
        })
        return menu;
    }

    static menuItem(menuItemAxiosResponse) {
        let menuItem = new MenuItem(
            menuItemAxiosResponse.id,
            menuItemAxiosResponse.version,
            menuItemAxiosResponse.force_url,
            menuItemAxiosResponse.route,
            menuItemAxiosResponse.text,
            menuItemAxiosResponse.menu_item_id,
            menuItemAxiosResponse.icon
        )

        menuItemAxiosResponse.children.forEach((subItem) => {
            menuItem.addChildren(this.menuItem(subItem))
        })

        menuItem.menuId = menuItemAxiosResponse.menu_id;

       return menuItem;
    }

    static async changeSort(menuId, payload) {
        const {data} = await axios.put(`${this.prefix}/menu/${menuId}/sort`, {
            items: payload
        })
        return data;
    }
}


export class Menu {
    constructor(id, title, description) {
        this.items = [];
        this.id = id;
        this.title = title;
        this.description = description;
    }
}
